import React from 'react';
import { useGetPage } from '../../../../../hooks/useGetPage';
import { pageIds } from '../../../../../utilities/constants';

export function NotificationPlaceholder() {
  const { data: locale } = useGetPage({
    locale: 'en',
    pageId: pageIds.NOTIFICATIONS,
  });

  return (
    <div
      className="flex flex-col h-[calc(70vh-150px)] px-[30px] items-center justify-center w-full"
      data-testid="notifications-empty"
    >
      <div className="text-btn-black text-title font-semibold">
        {locale.noNotification || 'No notifications yet'}
      </div>

      <div className="text-med-gray-3 text-center">
        {locale.noNotificationDescription ||
          'We’ll let you know as soon as there’s something new'}
      </div>
    </div>
  );
}
